import { RouteEntry } from "../../shared/routes";
import { ManageHome } from "./ManageHome";
import { IdentityRoles } from "../../configure/security/IdentityRoles";

export const manageRoutes: Array<RouteEntry> = [
    { path: '/manage', exact: true, component: ManageHome, authorize: true, requireRole: IdentityRoles.DriverManagement },
];
